import { createSlice } from '@reduxjs/toolkit';
import { addNewStaffMember, addUserCertificateEntity, editStaffMember, getAllStaffMembers, getStaffMemberById } from './staffService';

const initialState = {
  allStaffMembers: {
    isStaffMembersLoading: null,
    isStaffMembersSuccess: null,
    staffMembersMessage: null,
    pageCount: 0,
    staffMembers: [],
  },
  newStaffMember: {
    isStaffMemberCreating: null,
    isStaffMemberCreated: null,
    staffMemberCreationMsg: null,
  },

  editedStaffMember: {
    isEditingStaffMember: null,
    isStaffMemberEdited: null,
    staffMemberEditedMsg: null
  },

  userCertificateEntities: {
    isUserEntityCreating: null,
    userEntities: null,
  },

  staffMemberDetails: {
    isStaffMemberLoading: null,
    isStaffMemberSuccess: null,
    staffMember: null,
  },
};

const staffMembersSlice = createSlice({
  name: 'staffMember',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllStaffMembers.pending, (state) => {
        state.allStaffMembers = {
          ...initialState.allStaffMembers, // Reset to initial state
          isStaffMembersLoading: true,
          staffMembersMessage: 'Loading',
        };
      })
      .addCase(getAllStaffMembers.rejected, (state, action) => {
        state.allStaffMembers = {
          ...initialState.allStaffMembers,
          isStaffMembersLoading: false,
          isStaffMembersSuccess: false,
          staffMembersMessage: action.payload || 'Error occurred while fetching staffMembers',
        };
      })
      .addCase(getAllStaffMembers.fulfilled, (state, action) => {
        state.allStaffMembers = {
          ...initialState.allStaffMembers,
          isStaffMembersLoading: false,
          isStaffMembersSuccess: true,
          pageCount: action.payload.pageCount || 0,
          staffMembers: action.payload.data || [],
        };
      });

    //StaffMember creating
    builder
      .addCase(addNewStaffMember.pending, (state) => {
        state.newStaffMember = {
          ...initialState.newStaffMember, // Reset to initial state
          isStaffMemberCreating: true,
          staffMemberCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewStaffMember.rejected, (state, action) => {
        state.newStaffMember = {
          ...initialState.newStaffMember,
          isStaffMemberCreating: false,
          isStaffMemberCreated: false,
          staffMemberCreationMsg: action.payload || 'Error occurred while creating the staffMember.',
        };
      })

      // FULFILLED
      .addCase(addNewStaffMember.fulfilled, (state, action) => {
        state.newStaffMember = {
          ...initialState.newStaffMember,
          isStaffMemberCreating: false,
          isStaffMemberCreated: true,
          staffMemberCreationMsg: action.payload || 'Successfully created the staffMember.',
        };
      });

    //StaffMember editing
    builder
      .addCase(editStaffMember.pending, (state) => {
        state.editedStaffMember = {
          ...initialState.editedStaffMember, // Reset to initial state
          isEditingStaffMember: true,
          staffMemberEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editStaffMember.rejected, (state, action) => {
        state.editedStaffMember = {
          ...initialState.editedStaffMember, // Reset to initial state
          isEditingStaffMember: false,
          isStaffMemberEdited: false,
          staffMemberEditedMsg: action.payload || 'Error occurred while editing the staffMember.',
        };
      })

      // FULFILLED
      .addCase(editStaffMember.fulfilled, (state, action) => {
        state.editedStaffMember = {
          ...initialState.editedStaffMember, // Reset to initial state
          isEditingStaffMember: false,
          isStaffMemberEdited: true,
          staffMemberEditedMsg: action.payload || 'Successfully edited the staffMember.',
        };
      });

    //User certificate entity
    builder
      .addCase(addUserCertificateEntity.pending, (state) => {
        state.userCertificateEntities = {
          ...initialState.userCertificateEntities,
          isUserEntityCreating: true,
        };
      })

      .addCase(addUserCertificateEntity.rejected, (state, action) => {
        state.userCertificateEntities = {
          ...initialState.userCertificateEntities,
          isUserEntityCreating: false,
          userEntities: action.payload || 'Error occurred while creating user entities.',
        };
      })

      .addCase(addUserCertificateEntity.fulfilled, (state, action) => {
        state.userCertificateEntities = {
          ...initialState.userCertificateEntities,
          isUserEntityCreating: false,
          userEntities: action.payload || 'Successfully created certificate entities.',
        };
      });

    builder
      .addCase(getStaffMemberById.pending, (state) => {
        state.staffMemberDetails = {
          ...initialState.staffMemberDetails, // Reset to initial state
          isStaffMemberLoading: true,
          staffMemberMessage: 'Loading',
        };
      })
      .addCase(getStaffMemberById.rejected, (state, action) => {
        state.staffMemberDetails = {
          ...initialState.staffMemberDetails,
          isStaffMemberLoading: false,
          isStaffMemberSuccess: false,
        };
      })
      .addCase(getStaffMemberById.fulfilled, (state, action) => {
        state.staffMemberDetails = {
          ...initialState.staffMemberDetails,
          isStaffMemberLoading: false,
          isStaffMemberSuccess: true,
          staffMember: action.payload,
        };
      });

  },
});

export default staffMembersSlice.reducer;
